import { NOTIFY } from "./reducer";

export const getMsgSuccess = state => state.getIn([NOTIFY, 'success']);

export const getMsgError = state => state.getIn([NOTIFY, 'error']);

export default {};